import { ModuleGroups } from '../types/working-model';

export const MODULE_GROUP_DISPLAY_NAMES: Partial<Record<ModuleGroups, string>> = {
	[ModuleGroups.Engage]: 'Moments',
};
